import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  taxAdd: async ({ commit }, data) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/taxes/new-taxes', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getTaxData: async ({ commit }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/taxes/new-taxes')

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'taxes',
        data: res.data.taxes
      })

      return {
        data: res.data.taxes,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getStockPhotos: async ({ commit }, payload) => {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    return new Promise(async (resolve, reject) => {
      await axios
        .get('/stock-photo', {
          params: {
            limit,
            page,
            order,
            search
          }
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'stock_photos',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'total',
            data: response.data.totalCount
          })
          commit('SET_STATE', {
            action: 'FilteredCount',
            data: response.data.FilteredCount
          })
          resolve({
            data: response.data.data,
            FilteredCount: response.data.FilteredCount,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },
  uploadStockImages: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'POST',
      url: '/stock-photo',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer  ${accessToken}`
      },
      data: payload
    }

    try {
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return data
    } catch (err) {
      const { message } = getMessageFromError(err)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return Promise.reject({ message })
    }
  },
  async bulkDelete({ commit }, { ids }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'DELETE',
      url: '/stock-photo',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer  ${accessToken}`
      },
      data: { ids }
    }
    try {
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  updateStatus({ commit }, { id, status }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/stock-photo/${id}/update-status`, {
          status
        })
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  // get discount and tax by id
  getDiscountAndTaxById: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get(`/tax-and-discount/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { data: res.data.taxAndDiscount, message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  // insert user discount and tax setup
  insertDiscountAndTaxSetUp: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/tax-and-discount', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add or update system discount and tax setup
  addOrUpdateSystemDiscountAndTaxSetup: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/tax-and-discount/create-many', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // get system discount and tax
  getSystemDiscountAndTax: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const { page, limit, search, order, type } = payload

    try {
      const res = await axios.get('/tax-and-discount', {
        params: {
          limit,
          page,
          order,
          search,
          type
        }
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // data
      const discountAndTax = res.data.data
      const systemDiscountAndTax = discountAndTax.map(discountDetail => {
        return {
          ...discountDetail,
          id: discountDetail.id,
          name: discountDetail.name,
          value: discountDetail.value,
          city_tax: discountDetail.city_tax,
          state_tax: discountDetail.state_tax,
          county_tax: discountDetail.county_tax,
          type: discountDetail.type,
          status: discountDetail.status,
          discount_type: discountDetail.discount_type
        }
      })

      // system defined discount
      const tempSystemDiscount = systemDiscountAndTax.reduce((acc, item) => {
        if (item.type === 'system') {
          acc.push(item)
        }

        return acc
      }, [])

      if (tempSystemDiscount.length) {
        commit('SET_STATE', {
          action: 'FilteredCountSystemDiscount',
          data: res.data.FilteredCount
        })

        commit('SET_STATE', {
          action: 'totalSystemDiscount',
          data: res.data.totalCount
        })

        commit('SET_STATE', {
          action: 'systemDiscountAndTax',
          data: tempSystemDiscount
        })
      }

      // user defined discount
      const tempUserDiscount = systemDiscountAndTax.reduce((acc, item) => {
        if (item.type === 'user') {
          item.editMode = false
          acc.push(item)
        }

        return acc
      }, [])

      if (tempUserDiscount.length) {
        commit('SET_STATE', {
          action: 'FilteredCountUserDiscount',
          data: res.data.FilteredCount
        })

        commit('SET_STATE', {
          action: 'totalUserDiscount',
          data: res.data.totalCount
        })

        commit('SET_STATE', {
          action: 'userDiscountAndTax',
          data: tempUserDiscount
        })
      }

      return {
        data: res.data.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // delete discount and tax
  deleteDiscountAndTax: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/tax-and-discount/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return Promise.reject(err.response.data)
    }
  },
  // get  by  discount and tax ids
  getSystemDiscountAndTaxById: async (_, id) => {
    try {
      const res = await axios.get(`/tax-and-discount/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  // update discount and tax
  updateDiscountAndTax: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/tax-and-discount/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  // update status in discount and tax
  updateStatusDiscountAndTax: async ({ commit }, { id, status }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/tax-and-discount/${id}/update-status`, {
        status
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  // get SPF record
  getSpfRecords: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const { limit, page, order, search } = payload
    try {
      const res = await axios.get('/auth/spf-records', {
        params: {
          limit,
          page,
          order,
          search
        }
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'spfRecords',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.FilteredCount
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.FilteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get reward value setting
  getRedeemPointValues: async ({ commit }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/setting/reward-setup')

      commit('SET_STATE', {
        action: 'rewardSetup',
        data: res.data.rewardSetUp
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update redeem point values
  updateRedeemPointValues: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/setting/reward-setup', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update client or patients redeem points
  updateClientOrPatientReedemPoints: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.put(`/setting/edit-points/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get tiered pricing list
  getTieredPricingList: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/tiered-pricing', {
        params: {
          ...payload
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'tieredPricingList',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get tiered pricing list by tiered pricing ids
  getTieredPricingById: async (_, id) => {
    try {
      const res = await axios.get(`/tiered-pricing/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add tiered pricing
  addTieredPricing: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/tiered-pricing', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update tiered pricing
  updateTieredPricing: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`tiered-pricing/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete tiered pricing
  deleteTieredPricing: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/tiered-pricing/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get term condition
  getTermCondition: async ({ commit }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('setting/tnc')
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.tnc,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update term condition
  updateTermsCondition: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put('setting/tnc', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
